import { useState, useEffect } from 'react';
import Header from '../components/general/Header';
import Footer from '../components/general/Footer';
import FanMap from '../components/shows/FanMap';
import JoinFans from '../components/shows/JoinFans';
import { getCommunity } from '../utils/api/communityApi';
import { clusterFansIntoAreas } from '../utils/clusterFans';
import s from '../styles/pages/TourMap.module.css';
import site from '../data/master.json';

export default function TourMap() {
  const [areas, setAreas] = useState(site.tourMap.areas); // mock fallback while loading

  useEffect(() => {
    getCommunity()
      .then((coordinates) => {
        const clustered = clusterFansIntoAreas(site.tourMap.areas, coordinates);
        setAreas(clustered);
      })
      .catch((err) => console.error(err)); // keeps the mock areas on failure
  }, []);

  return (
    <div className={s.container}>
      <Header />
      <FanMap data={{ ...site.tourMap, areas }} />
      <div className={s.join}>
        <JoinFans data={site.tourMap.join} />
      </div>
      <Footer data={site.footer} />
    </div>
  );
}